import React from 'react';

const Facebook = () => (
	<svg viewBox="0 0 48 48" className="icon facebook">
		<path d="M34,12H14a2,2,0,0,0-2,2V34a2,2,0,0,0,2,2H24V27.47H21.7a.71.71,0,0,1-.71-.7l0-2.33a.83.83,0,0,1,.83-.85H24V21c0-3,1.77-4.89,4.3-4.89h2.49a.5.5,0,0,1,.5.5V19s0,.55-.5.55H30c-1.59,0-2.4.13-2.4,1.86V23.6h3.26a.58.58,0,0,1,.58.65l-.33,2.6a.71.71,0,0,1-.7.62h-2.8V36H34a2,2,0,0,0,2-2V14A2,2,0,0,0,34,12Z"/>
  </svg>
);

export default Facebook;



// WEBPACK FOOTER //
// ./src/components/Icons/Facebook.js